import { Fragment } from 'react'
import * as S from './AttributionChannelSelectorExpanded.styles'
import AttributionSubChannel from './AttributionSubChannel'
import BlurryBackground from '../../../components/BlurryBackround/BlurryBackground'
import { channelsToTranslatedChannels } from '../../../services/AttributionSurveyManager'
import {
  SUB_ATTRIBUTION_ANALYTICS_OPTIONS,
  TRANSLATED_SUB_ATTRIBUTION_OPTIONS,
} from './subattributions.consts'
import { useTranslation } from 'react-i18next'
import { LANGUAGES } from 'locale/Translation.consts'
import { useLanguage } from 'services/LangProvider'

export default function AttributionChannelSelectorExpanded({
  title,
  isSelected,
  transformOrigin,
  options,
  onOptionClick,
  onClickAway,
}: {
  title: string
  isSelected: boolean
  transformOrigin: string | undefined
  options: string[]
  onOptionClick: ({
    e,
    channelName,
    subChannel,
  }: {
    e: React.MouseEvent<HTMLDivElement>
    channelName: string
    subChannel?: string
  }) => void
  onClickAway: (e: React.MouseEvent<HTMLDivElement>) => void
}) {
  const { t } = useTranslation()
  const language = useLanguage()
  const isEnglish = language === LANGUAGES.ENGLISH

  return (
    <>
      <BlurryBackground
        show={isSelected}
        onClick={onClickAway}
        backgroundColor="rgba(0, 0, 0, 0.20)"
        backdropFilter="blur(2px)"
      />
      <S.Container
        initial={false}
        $position={transformOrigin}
        $wide={!isEnglish}
        $isSelected={isSelected}
        animate={{
          scaleX: isSelected ? 1 : 0.86,
          scaleY: isSelected ? 1 : 0.4,
          opacity: isSelected ? 1 : 0,
          zIndex: isSelected ? 1602 : 0,
          transformOrigin,
        }}
        transition={{
          duration: 0.15,
          ease: 'easeInOut',
        }}
      >
        <S.Title>
          {t((channelsToTranslatedChannels as Record<string, string>)[title])}:
        </S.Title>
        <S.Options>
          {options.map((option, index) => (
            <Fragment key={option}>
              <AttributionSubChannel
                text={t(
                  TRANSLATED_SUB_ATTRIBUTION_OPTIONS[
                    option as keyof typeof TRANSLATED_SUB_ATTRIBUTION_OPTIONS
                  ]
                )}
                onClick={(e) =>
                  isSelected &&
                  onOptionClick({
                    e,
                    channelName: title,
                    subChannel:
                      SUB_ATTRIBUTION_ANALYTICS_OPTIONS[
                        option as keyof typeof SUB_ATTRIBUTION_ANALYTICS_OPTIONS
                      ],
                  })
                }
              />
              {index !== options.length - 1 && <S.Separator />}
            </Fragment>
          ))}
        </S.Options>
      </S.Container>
    </>
  )
}
